import BirthdateForm from './BirthdateForm';

export default BirthdateForm;
